import { FaGamepad, FaBook, FaQuestionCircle, FaVolumeUp, FaTasks } from "react-icons/fa";

export const projects = [
  {
    id: 1,
    title: "Number Guessing Game",
    description: "A game where the player guesses a random number.",
    tech: "Java programming langauage",
    github: "https://github.com/Neelamma-S/NumberGuessingGame",
    icon: FaGamepad,
  },
  {
    id: 2,
    title: "Library Management System",
    description: "Manage books, users, and borrowing efficiently.",
    tech: "Java programming langauage",
    github: "https://github.com/Neelamma-S/LibraryManagementSystem",
    icon: FaBook,
  },
  {
    id: 3,
    title: "Quiz Game Web Application",
    description: "An online quiz platform with multiple categories.",
    tech: "JavaScript, HTML, CSS",
    github: "https://github.com/Neelamma-S/Quiz-Game",
    icon: FaQuestionCircle,
  },
  {
    id: 4,
    title: "Text-to-Speech Web Application",
    description: "Convert text into speech using modern TTS APIs.",
    tech: "JavaScript, HTML, CSS",
    github: "https://github.com/Neelamma-S/Text_to_speech",
    icon: FaVolumeUp,
  },
  {
    id: 5,
    title: "To-Do List Web Page",
    description: "A simple, responsive To-Do List web page. Add, complete, and delete tasks, all saved in localStorage.",
    tech: "HTML, CSS, JavaScript",
    github: "https://github.com/Neelamma-S/To-Do-List",
    icon: FaTasks,
  },
];
